var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmartphoneLandscape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 73,
    viewBox: "0 0 152 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_205_462)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.991 70.8943L139.413 55.0273V36.5158C139.413 29.4638 126.015 21.9217 120.902 18.0043",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.707 41.0785L114.844 30.7684C113.983 29.9067 112.814 29.4225 111.595 29.4225C110.376 29.4225 109.208 29.9067 108.346 30.7684C107.484 31.6302 107 32.799 107 34.0176C107 34.6209 107.119 35.2186 107.35 35.7761C107.581 36.3335 107.919 36.8402 108.346 37.2668L120.807 51.325V60.14C120.807 64.3042 126.755 70.8767 126.755 70.8767",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.00861 70.8943L12.5866 55.0273L12.5866 36.5158C12.5866 29.4638 25.9854 21.9217 31.0981 18.0043",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2929 41.0785L37.1557 30.7684C38.0175 29.9067 39.1864 29.4225 40.4049 29.4225C41.6235 29.4225 42.7924 29.9067 43.6542 30.7684C44.5159 31.6302 45 32.799 45 34.0176C45 34.6209 44.8811 35.2186 44.6503 35.7761C44.4193 36.3335 44.0808 36.8402 43.6542 37.2668L31.1933 51.325L31.1933 60.14C31.1933 64.3042 25.2449 70.8767 25.2449 70.8767",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 34.6126L120 13.3876C119.991 10.6909 119.028 8.0834 117.28 6.02171C115.531 3.96002 113.109 2.57625 110.437 2.1125L44.5714 2C41.2373 2 38.0397 3.3171 35.6821 5.66129C33.3245 8.00548 32 11.1851 32 14.5001L32 34.6126M116.647 50.6659C115.583 51.7234 114.321 52.5622 112.931 53.1343C111.541 53.7064 110.051 54.0005 108.547 54L43.4484 54C41.9446 54 40.4555 53.7054 39.0663 53.1331C37.677 52.5607 36.4148 51.7219 35.3517 50.6644",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109 30V15C109 12.7909 107.209 11 105 11L47 11C44.7909 11 43 12.7909 43 15V30M109 38.5V41C109 43.2091 107.209 45 105 45L47 45C44.7909 45 43 43.2091 43 41V38.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_205_462"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 73,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartphoneLandscape);
export default __webpack_public_path__ + "static/media/smartphone-landscape.902668aa818d16cba49b70191c38406d.svg";
export { ForwardRef as ReactComponent };